module.exports = __webpack_public_path__ + "static/sport/register-success-new.2844e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/register-success-new.png
// module id = ugj5
// module chunks = 0